export default __webpack_public_path__ + "static/media/sliderOpensvg.04d831a2.svg";